<template>
  <div
    role="group"
    class="flex flex-col gap-0.5"
    :aria-labelledby="labelId"
    :aria-describedby="valueId"
  >
    <span :id="labelId" class="opacity-60 font-bold text-sm leading-tight flex gap-1 items-center">
      <slot name="label">
        {{ label }}
      </slot>
    </span>
    <span
      :id="valueId"
      class="leading-tight"
      :class="{
        'text-base': size === 'sm',
        'text-lg': size === 'md',
        'text-xl': size === 'lg',
      }"
    >
      <slot />
    </span>
  </div>
</template>
<script setup lang="ts">
import {useId} from 'vue';

const labelId = useId();
const valueId = useId();

const {size = 'md'} = defineProps<{
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}>();
</script>
